import { Link, useParams } from "react-router-dom";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useEffect, useState } from "react";
import { useFetch } from "../hooks/useFetch";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
import Skeleton from "react-loading-skeleton";
import Loading from "../components/Loading";
import { Helmet } from "react-helmet";
import HeaderImg from "../components/HeaderImg";
import ProductItemCard from "../components/ProductItemCard";

function NewsDetails() {
  // const [news, setNews] = useState([1, 2, 3, 4]);
  const { slug } = useParams();

  const [relatedUrl, setrelatedUrl] = useState("");
  const [moveToTop, setMoveToTop] = useState(false);
  const [relatedData, setRelatedData] = useState(null);

  const { data, loading } = useFetch(`/blog/${slug}`);
  const { data: products, loading: loadingProduct } = useFetch(
    `/product/best-sellers/1`,
  );
  const {
    data: related,
    loading: loadingRelated,
    refetch,
  } = useFetch(relatedUrl);

  useEffect(() => {
    if (data?.tag) {
      setrelatedUrl(`/blog/all/1/4/${data?.tag?.replace(/ /g, "_")}`);
    }
  }, [data?.tag]);

  useEffect(() => {
    if (related?.blogs?.length > 0 && slug) {
      const newRelated = related?.blogs?.filter((item) => item?.slug !== slug);
      setRelatedData(newRelated);
    }
  }, [related, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [moveToTop]);
  const dataLoading = [1, 2, 3, 4];

  return (
    <div>
      <HeaderImg title="News Details" />

      <div className="newsDetails">
        {data && (
          <Helmet>
            <title>{data?.title}</title>
            <meta property="og:title" content={data?.title} />
            <meta property="og:description" content={data?.summary} />
            <meta
              property="og:image"
              content={process.env.REACT_APP_API_URL + data?.coverUrl}
            />
            <meta
              property="og:url"
              content={"https://chaolcaringtonltd.com/news/" + data?.slug}
            />
            <meta property="og:type" content="article" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={data?.title} />
            <meta name="twitter:description" content={data?.title?.summary} />
            <meta
              name="twitter:image"
              content={process.env.REACT_APP_API_URL + data?.coverUrl}
            />
          </Helmet>
        )}

        <div className="newsDetails__wrapper">
          {loading ? (
            <Loading />
          ) : (
            <div className="newsDetails__main">
              <div className="newsDetails__main__top">
                <Link to={`/news?tag=${data?.tag?.replace(/ /g, "_")}`}>
                  <span className="newsDetails__main__top__tag">
                    {data?.tag}
                  </span>
                </Link>
                <p>
                  <i className="bx bx-calendar-alt"></i>
                  {moment(data?.createdAt).format("Do MMM, YYYY hh:mm:ss a")}

                  {/* 9th July 2025, 3:32:34 pm */}
                </p>
              </div>
              <h1>{data?.title}</h1>
              <div className="newsDetails__main__info">
                <div className="newsDetails__main__info__img">
                  {/* <img src={adminImg} alt="" /> */}
                  <p>Chaol Carington Admin</p>
                </div>

                <div className="newsDetails__main__info__read">
                  <i className="bx bx-eye"></i> 3 Minute Read
                </div>
              </div>
              <div className="newsDetails__main__img">
                <img
                  src={process.env.REACT_APP_API_URL + data?.coverUrl}
                  alt=""
                />
              </div>

              <div className="newsDetails__main__text">
                <aside className="newsDetails__main__text__left">
                  <div className="newsDetails__main__text__left__main">
                    <FacebookShareButton
                      url={"https://chaolcaringtonltd.com/news/" + data?.slug}
                      quote={data?.title}
                    >
                      <FacebookIcon size={33} />
                    </FacebookShareButton>
                    <TwitterShareButton
                      url={"https://chaolcaringtonltd.com/news/" + data?.slug}
                      quote={data?.title}
                    >
                      <TwitterIcon size={33} />
                    </TwitterShareButton>
                    <TelegramShareButton
                      url={"https://chaolcaringtonltd.com/news/" + data?.slug}
                      quote={data?.title}
                    >
                      <TelegramIcon size={33} />
                    </TelegramShareButton>
                    <WhatsappShareButton
                      url={"https://chaolcaringtonltd.com/news/" + data?.slug}
                      quote={data?.title}
                    >
                      <WhatsappIcon size={33} />
                    </WhatsappShareButton>
                    <EmailShareButton
                      url={"https://chaolcaringtonltd.com/news/" + data?.slug}
                      quote={data?.title}
                    >
                      <EmailIcon size={33} />
                    </EmailShareButton>
                  </div>
                </aside>
                <div
                  style={{ minHeight: 300, marginBottom: 50 }}
                  className="newsDetails__main__text__blog"
                  dangerouslySetInnerHTML={{
                    __html: data?.content,
                  }}
                ></div>
              </div>

              {/* <div className="newsDetails__main__bottom">
            <div className="newsDetails__main__bottom__left">
              <Link to={`/news?tag=casino`}>
                <span className="newsDetails__main__top__tag">Casino</span>
              </Link>

             
            </div>
          </div> */}
            </div>
          )}

          <div className="newsDetails__wrapper__rel">
            <h3 style={{ marginBottom: 20 }}>Featured Products</h3>
            {loadingProduct ? (
              <Loading />
            ) : (
              <div
                className="newsDetails__wrapper__rel__main"
                style={{ display: "flex", gap: 15, flexDirection: "column" }}
              >
                {products?.products?.slice(0, 3)?.map((product) => {
                  return <ProductItemCard key={product.id} product={product} />;
                })}
              </div>
            )}
          </div>
        </div>

        <div className="newsDetails__related">
          <h2 className="mainTitle" style={{ marginBottom: 20 }}>
            Related News
          </h2>
          <div className="newsDetails__related__list">
            {loadingRelated ? (
              <>
                {dataLoading?.map((item) => {
                  return (
                    <div key={item} className="news__alt__main__item">
                      <div style={{ marginBottom: 10 }}>
                        <Skeleton height={150} />
                      </div>
                      <Skeleton count={4} />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {relatedData?.map((item) => {
                  return (
                    <Link
                      key={item?.id}
                      onClick={() => setMoveToTop((curr) => !curr)}
                      to={`/news/${item?.slug}`}
                    >
                      <div className="news__alt__main__item">
                        <div className="news__alt__main__item__img">
                          <img
                            src={process.env.REACT_APP_API_URL + item?.coverUrl}
                            alt=""
                          />
                        </div>
                        <div className="news__alt__main__item__cont">
                          <div className="news__alt__main__item__cont__top">
                            <Link
                              to={`/news?tag=${item?.tag?.replace(/ /g, "_")}`}
                            >
                              <span className="news__alt__main__item__cont__top__tag">
                                {item?.tag}
                              </span>
                            </Link>

                            <p>
                              <i className="bx bx-calendar-alt"></i>{" "}
                              {moment(item?.createdAt).format("Do MMM, YYYY")}
                            </p>
                          </div>

                          <h3 className="alt">
                            <LinesEllipsis
                              text={item?.title}
                              maxLine="2"
                              ellipsis="..."
                              trimRight
                              basedOn="letters"
                            />
                          </h3>

                          <p className="news__alt__main__item__cont__desc">
                            <LinesEllipsis
                              text={item?.summary}
                              maxLine="3"
                              ellipsis="..."
                              trimRight
                              basedOn="letters"
                            />
                          </p>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetails;
